import React, {
  FC, useMemo, useState, useEffect,
} from 'react';
import { connect } from 'react-redux';
import RenderContent from 'app/components/layout/RenderContent';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import SectionGroup from 'app/components/general/SectionGroup';
import HeaderThin from 'app/components/layout/HeaderThin';
import { IApplicationState } from 'app/types/state';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import * as teamActions from 'app/ducks/teams/actions';
import * as dashboardActions from 'app/ducks/dashboard/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamSelectors from 'app/ducks/teams/selectors';
import * as seasonSelectors from 'app/ducks/seasons/selectors';

import DashboardSingleTeam from './components/DashboardSingleTeam';
import DashboardAllTeams from './components/DashboardAllTeams';

interface IProps {
  actions: any;
  dashboard: any;
  teams: any;
  seasons: any;
  match: any;
  appReady: boolean;
  updateTeamSelection: Function;
}

interface IState {
  selectedTeam: any;
}

const selector = (state): any => ({
  teams: {
    ...teamSelectors.getTeams(state),
    getPaymentIds: (teamId) => teamSelectors.getPaymentIds(state, teamId),
    getTeamMemberIds: (teamId) => teamSelectors.getTeamMemberIds(state, teamId),
    getCurrentTeam: () => teamSelectors.getCurrentTeam(state),
  },
  seasons: seasonSelectors.getSeasons(state),
  dashboard: state.dashboard,
  appReady: loadingSelectors.appReady(state),
});

const actionCreators = _.merge(
  teamActions,
  dashboardActions,
);

const DashboardLayout: FC<IProps> = (props: IProps = {
  actions: undefined,
  dashboard: undefined,
  teams: undefined,
  seasons: undefined,
  match: undefined,
  appReady: false,
}) => {
  const defaultTeamSelection = {
    id: 'all-teams',
    name: 'All Teams',
  };

  // const [defaultSeasonSelection, setDefaultSeasonSelection] = useState(null);
  const selectedTeam = props.dashboard.teamSelection;

  const handleSelectTeam = (e: any): void => {
    props.actions.updateTeamSelection(e);
  };

  const teamOptions = _.concat([defaultTeamSelection], props.teams?.teamsByIdInSelectFormat);

  useEffect(() => {
    props.actions.getAllTeams();
  }, []);

  // useEffect(() => {
  //   if (props.dashboard.seasonSelection === undefined, selectedTeam?.id === 'all-teams') {
  //     handleSelectSeason(defaultSeasonSelection);
  //   }
  // }, [defaultSeasonSelection, selectedTeam]);

  // useEffect(() => {
  //   if (selectedTeam?.id === 'all-teams') {
  //     setDefaultSeasonSelection({
  //       id: props.seasons.seasonsById[props.seasons.seasonIds[0]]?.id,
  //       name: props.seasons.seasonsById[props.seasons.seasonIds[0]]?.name,
  //     });
  //   }
  // }, [JSON.stringify(props.seasons.seasonsById), selectedTeam]);

  return (
    <RenderContent className="dashboard-app" match={props.match}>
      <div className="row">
        <div className="col">
          <HeaderThin title="Your Dashboard" divider>
            <div className="col col-12 col-md-12 col-lg-6 header-thin-children margin-md-top-20">
              <div className="input-grid-20">
                <InputGroupBlock
                  name="team"
                  // labelText="Time Period"
                  className="no-margin-bottom float-right w-100"
                  inputGroupClassName="no-margin-bottom w-100"
                  placeholder="Team"
                  type="select"
                  options={teamOptions}
                  value={selectedTeam}
                  onChange={handleSelectTeam}
                />
              </div>
            </div>
          </HeaderThin>
        </div>
      </div>
      {selectedTeam?.id === 'all-teams' && (<DashboardAllTeams {...props} />)}
      {selectedTeam?.id !== 'all-teams' && (<DashboardSingleTeam {...props} teamId={selectedTeam?.id} />)}

      {/* {props.users.currentUser.userType === 'team' && (
          <MyDashboardNotifications
            actions={props.actions}
            currentTeam={props.teams.currentTeam}
          />
        )}
        {props.teams.currentTeam.connectedToAssociation && (
          <MyDashboardUpcomingMatches
            actions={props.actions}
            currentTeam={props.teams.currentTeam}
          />
        )}
        <div className="row">
          <div className="col">
            <MyDashboardPayments
              actions={props.actions}
              appReady={props.appReady}
              payments={props.payments}
              teamMemberIds={props.teamMembers?.currentTeam?.teamMemberIds}
              reminders={props.reminders}
            />
          </div>
        </div> */}
    </RenderContent>
  );
};

export default connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))(DashboardLayout);
